export default {
    attempted: 'Tentative | Tentatives',
    pending: 'Attente',
    reached: 'Rejoint',
};
